import React, { useState } from 'react';
import { ReactMic } from 'react-mic';
import { useSharedState } from '../hooks/SharedStateContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faStop, faMicrophoneSlash } from '@fortawesome/free-solid-svg-icons';

import './Recording.css'

export default function ConversationToggle() {
// class Recording extends React.Component {

  // https://github.com/hackingbeauty/react-mic?tab=readme-ov-file

  const { sharedState, setSharedState } = useSharedState();
  const [isStopping, setIsStopping] = useState(false);

  const startRecording = () => {
    setSharedState(prevState => ({
      ...prevState,
      record: true,
      // Don't set loading to false here - let the connection status handle it
    }));
  }

  const stopRecording = () => {
    if (sharedState.isRealtime) {
      // In realtime mode, trigger complete conversation finish/reset
      setSharedState(prevState => ({
        ...prevState,
        finishRecording: true, // This will trigger finishConversation in Conversation.jsx
        record: false,
        loading: false,
        talking: false,
      }));
    } else {
      // Keep recording for 500ms after the user clicks stop to avoid clipping
      // the last words. The button is disabled immediately to prevent double-clicks.
      setIsStopping(true);
      setTimeout(() => {
        setIsStopping(false);
        setSharedState(prevState => ({
          ...prevState,
          record: false,
          loading: false,
          finishRecording: true,
          talking: false,
          lastRecordedBlob: null
        }));
      }, 500);
    }
  };

  const toggleMicrophone = () => {
    setSharedState(prevState => ({
      ...prevState,
      micMuted: !prevState.micMuted,
    }));
  };

  /** REALTIME */
  return (
    <div className="recording-controls"> 
      {sharedState.firstUserInput && 
        <div className="recording-panel recording-panel--realtime">

          <div className="recording-button-row">
            {(!sharedState.record || (sharedState.record && sharedState.loading)) && (
              <button 
                disabled={sharedState.loading} 
                onClick={startRecording} 
                className="recording-control" 
                type="button">
                <FontAwesomeIcon icon={faMicrophone} />
              </button>
            )}
          </div>

          <ReactMic
            record={sharedState.record && !sharedState.loading}
            visualSetting="sinewave" 
            className={`sound-wave ${sharedState.record ? '' : 'hidden'}`}
            mimeType="audio/mp3" // Ensure the correct MIME type
            strokeColor="#000000"
            backgroundColor="#FFFFFF" />

          <div className="recording-button-row">
            {sharedState.record && !sharedState.loading && (
              <div className="realtime-recording-actions">
                <button
                  className="recording-control volume"
                  onClick={toggleMicrophone}
                  type='button'
                  title={sharedState.micMuted ? "Unmute microphone" : "Mute microphone"}>
                    <FontAwesomeIcon icon={sharedState.micMuted ? faMicrophoneSlash : faMicrophone} />
                </button>

                <button
                  disabled={sharedState.loading || isStopping}
                  onClick={stopRecording}
                  className="recording-control recording"
                  type="button">
                  <FontAwesomeIcon icon={faStop} />
                </button>
              </div>
            )}
          </div>

        </div>
      }
    </div>
  );
}
